import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Alert, Button, Card, Input, Statistic, Table, Tag, Typography } from "antd";
import { useState } from "react";
import { useAppConfig } from "../../shared/config/AppConfigProvider";
import { formatCurrency, formatMileage } from "../../shared/utils/formatters";
import { operationsApi } from "./operations-api";

export function InventoryTestPage() {
  const { locale } = useAppConfig();
  const zh = locale === "zh";
  const [searchInput,setSearchInput] = useState("");
  const [search,setSearch] = useState("");
  const inventory = useQuery({ queryKey: ["inventory-test",search], queryFn: () => operationsApi.inventory(search) });
  const totalUnits = (inventory.data ?? []).reduce((sum, item) => sum + item.onHand, 0);
  const totalCost = (inventory.data ?? []).reduce((sum, item) => sum + item.onHand * Number(item.unitCost), 0);

  return <section>
    <div className="page-title business-page-title">
      <div>
        <Typography.Title level={2}>{zh ? "库存" : "Inventory"}</Typography.Title>
        <Typography.Paragraph type="secondary">
          {zh ? "测试入口：库存数量由库存交易实时汇总，不允许直接修改。" : "Testing access: on-hand quantity is derived from inventory transactions and cannot be edited directly."}
        </Typography.Paragraph>
      </div>
      <Button icon={<ReloadOutlined />} loading={inventory.isFetching} onClick={() => void inventory.refetch()}>{zh ? "刷新" : "Refresh"}</Button>
    </div>
    {inventory.isError && <Alert type="error" showIcon message={String(inventory.error)} />}
    <Alert type="info" showIcon message={zh ? "测试版已开放" : "Testing access enabled"} description={zh ? "采购收货会生成 RECEIPT 库存交易，并同步更新这里的数量。" : "Purchase receiving creates a RECEIPT inventory transaction and updates this balance."} />
    <Input.Search
      className="inventory-search"
      value={searchInput}
      onChange={event => setSearchInput(event.target.value)}
      onSearch={value => setSearch(value.trim())}
      allowClear
      enterButton={<><SearchOutlined /> {zh ? "搜索" : "Search"}</>}
      placeholder={zh ? "通过配件号、名称或车型搜索" : "Search by part number, name, or vehicle"}
    />
    <div className="operations-stat-grid">
      <Card><Statistic title={zh ? "材料种类" : "Items"} value={inventory.data?.length ?? 0} /></Card>
      <Card><Statistic title={zh ? "库存总数量" : "Units on hand"} value={totalUnits} formatter={value => formatMileage(value)} /></Card>
      <Card><Statistic title={zh ? "库存成本" : "Inventory cost"} value={totalCost} formatter={value => formatCurrency(value)} /></Card>
    </div>
    <Card>
      <Table
        rowKey="id"
        loading={inventory.isLoading}
        dataSource={inventory.data ?? []}
        scroll={{ x: 760 }}
        columns={[
          { title: "SKU", dataIndex: "sku", key: "sku", render: value => <Typography.Text className="mono">{value}</Typography.Text> },
          { title: zh ? "材料名称" : "Item", dataIndex: "name", key: "name" },
          { title: zh ? "适用车型" : "Vehicle application", dataIndex: "vehicleApplication", key: "vehicleApplication", render: value => value || "—" },
          { title: zh ? "库存数量" : "On hand", dataIndex: "onHand", key: "onHand", align: "right", render: value => <Tag color={value > 0 ? "green" : "red"}>{formatMileage(value)}</Tag> },
          { title: zh ? "成本" : "Cost", dataIndex: "unitCost", key: "cost", align: "right", render: formatCurrency },
          { title: zh ? "售价" : "Price", dataIndex: "unitPrice", key: "price", align: "right", render: formatCurrency }
        ]}
      />
    </Card>
  </section>;
}
